module.exports = __webpack_public_path__ + "img/sport-11-@3x.1a62a6ab.png";